import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import '../../internals/89afd3114d9c158f62e0e21a82cf39c4eddcf7acec690559797227aa316f9264.cfe-internal.js';
import { useDragDropManager } from '../2c2a08c7de500853fb7e7fc6c23b7488305aacbb55475e14a20fb57649979a77.cfe-internal.js';
import { useIsomorphicLayoutEffect } from '../e6bd8d9d193665651547f77cb2adacf0dae81d061654707a931bdfc0fd619642.cfe-internal.js';
import { useAccept } from './e6b534365924e2d9aa5959b88eda96eeaea559b3a197f45745f109bf2b43b400.cfe-internal.js';
import { useDropTarget } from './2bb15b3564513e8352eeacb96d817082c971c99de21249e29fa90b917ce5fed7.cfe-internal.js';
import { registerTarget } from '../../internals/06b39944ae11f4054ab74e07df5a51b41fa8320b8b5de5e22f31d0e4a8aa29db.cfe-internal.js';

function useRegisteredDropTarget(spec, monitor, connector) {
  var manager = useDragDropManager();
  var dropTarget = useDropTarget(spec, monitor);
  var accept = useAccept(spec);
  useIsomorphicLayoutEffect(function registerDropTarget() {
    var _registerTarget = registerTarget(accept, dropTarget, manager),
      _registerTarget2 = _slicedToArray(_registerTarget, 2),
      handlerId = _registerTarget2[0],
      unregister = _registerTarget2[1];
    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [manager, monitor, dropTarget, connector, _mapInstanceProperty(accept).call(accept, function (a) {
    return a.toString();
  }).join('|')]);
}

export { useRegisteredDropTarget };
